import React, { useRef } from "react"
import PropTypes from "prop-types"
import {
    Box,
    Typography,
    InputBase,
} from "@mui/material"
import UploadComponent from "src/v2/components/upload/upload-component"
import theme from "src/v2/theme/theme"
import GridRadioButton from "src/v2/components/radio-button/grid-radio-button"

const MODELO_PROJETAR = "MC_EmissaoRendaFixaParametros"

const removeExtensaoArquivo = (fileName = "") => {
    return fileName.replace(/\.[^/.]+$/, "")
}

const CadastroLoteUpload = ({
    nameFile,
    setNameFile,
    projetar,
    setProjetar,
    onSend,
}) => {
    const fileInputRef = useRef(null)

    const habilitaProjetar = nameFile === MODELO_PROJETAR

    const handleFileSelect = (file) => {
        if (!file) {
            setNameFile("")
            return
        }

        setNameFile(removeExtensaoArquivo(file.name))
    }

    const handleEnviar = (file) => {
        if (!file) return

        onSend?.({
            arquivo: file,
            modelo: nameFile,
            projetar,
        })
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
            }}
        >
            <Box>
                <Typography
                    sx={{
                        color: theme.palette.primary.contrastText,
                        mb: 1,
                    }}
                >
                    MODELO DO ARQUIVO
                </Typography>

                <InputBase
                    value={nameFile}
                    onChange={(event) => setNameFile(event.target.value)}
                    sx={{
                        width: "100%",
                        color: theme.palette.primary.contrastText,
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        pb: 0.5,
                    }}
                />
            </Box>


            {habilitaProjetar && (
                <Box
                    sx={{
                        width: "180px",
                    }}

                >
                    <GridRadioButton
                        title="PROJETAR"
                        value={projetar}
                        defaultRadioValue="nao"
                        onChange={(event) => setProjetar(event.target.value)}
                        radioButtonItems={[
                            { value: "sim", label: "SIM" },
                            { value: "nao", label: "NÃO" },
                        ]}
                        columns={2}
                        direction="row"
                        itemsPerColumn={1}
                        spacing={{ mt: 0, mb: 0 }}
                        horizontalSpacing={0.5}
                    />
                </Box>
            )}


            <Box
                sx={{
                    width: "75%",
                    minWidth: "700px",
                    maxWidth: "1000px",
                    alignSelf: "center",
                    mb: 2,
                    mt: 2,
                }}
            >
                <UploadComponent
                    compact
                    fileInputRef={fileInputRef}
                    onFileSelect={handleFileSelect}
                    onSendFile={handleEnviar}
                />
            </Box>
        </Box>
    )
}

CadastroLoteUpload.propTypes = {
    nameFile: PropTypes.string.isRequired,
    setNameFile: PropTypes.func.isRequired,
    projetar: PropTypes.string.isRequired,
    setProjetar: PropTypes.func.isRequired,
    onSend: PropTypes.func,
}

export default CadastroLoteUpload